import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export class CheckGigyaUserExistsUserUseCase extends UseCase {
  constructor({config, userRepository}) {
    super()
    this._config = config
    this._userRepository = userRepository
  }

  /**
   * @return {Promise<Object, Error>} returns exists boolean
   * @property {Object} exists
   */
  @tracer({metric: 'CheckGigyaUserExistsUserUseCase#execute'})
  @inlineError
  async execute({gigyaResponse}) {
    const {UID: gigyaUID} = gigyaResponse || {}

    const [error, response] = await this._userRepository.checkGigyaUserExists({
      gigyaUID
    })

    if (error) return Promise.reject(error)

    const {userExists} = response.toJSON()

    return userExists
  }
}
